<template>
  <b-table small thead-class="thead-light text-dark"
           :items="filesWithDefaultCategory" :fields="kickoffFilesSetting">
    <template #cell(category)="data">
      <div class="row">
        <div v-if="data.item.parent" class="col-1">
          <button class="btn btn-sm btn-link p-0 btn-svg fontawesome-chevron-down" type="button"
                  style="width: calc(1em + 0.3rem - 2.5px);height: calc(1em + 0.3rem + 0px);margin-bottom: 2px;"
                   @click="ExpandFileCategory(data.item.category)"></button>
        </div>
        <div class="col-4 align-self-end">
          <span>{{ data.item.category }}</span>
        </div>
      </div>
    </template>
    <template #cell(file_name)="data">

      <div v-if="_.trim(data.item.file_source)==='ETO'|| data.item.file_source == null">
        <div v-if="readonly">
          <a v-if="_.trim(data.item.file_name) !== ''" class="file" herf="#" @click="getFile(data.item)"> {{data.item.file_name}}</a>
        </div>
        <div v-else class="row mx-n1 align-items-center">
          <template v-if="_.trim(data.item.file_name) === ''">
            <div class="px-1 col-auto d-flex align-items-center">
              <!--<label class="btn btn-primary btn-sm mb-0">
    <span>Upload</span>
    <input type="file" class="d-none" v-on:change="uploadFile($event, data.item.category)" />
  </label>-->
              <b-form-file v-model="data.item.temp_file"
                           class="pr-1"
                           ref="proposalFileInput"
                           placeholder="Please select or drop file..."
                           drop-placeholder="Drop your file here..."></b-form-file>
              <b-button class="ml-2" @click="uploadFile(data.item.temp_file, data.item.category)" variant="primary">Upload</b-button>
            </div>
            <div class="col text-danger">Please upload this required file.</div>
          </template>
          <template v-else>
            <div class="px-1 col-auto">
              <a class="file" herf="#" @click="getFile(data.item)"> {{data.item.file_name}}</a>
            </div>
            <div class="px-1 col-auto" v-if="!readonly && _.trim(data.item.file_name) !== ''">
              <button type="button" class="btn btn-link p-0 btn-svg gtc-icon-cancel btn-sm"
                      @click="deleteFile(data.item, data.item.category)"></button>
            </div>
          </template>
        </div>
      </div>
      <div v-else>
        <span>{{data.item.file_name}}</span>
      </div>


    </template>
    <template #cell(update_time)="data">
      {{ data.item.update_time | dateTimeFormat }}
    </template>
  </b-table>
</template>

<script>
  export default {
    name: 'nre-kickoff-files',
    props: {
      prop_kickoff_files: {
        type: Array,
        default: []
      },
      prop_readonly: {
        type: Boolean,
        default: true
      },
      prop_basic_info: {
        type: Object,
        default: null
      }
    },
    data: function () {
      return {
        kickoff_files: [],
        kickoffFilesSetting: [],
        readonly: false,
        missRequiredFile: false,
        basic_info: {
          login_user: null,
          createBy: null,
          ftie_id: null,
          nre_id: null,
          real_sku_no: null,
          sku_id: null
        },
        expand_category_list:[]
      }
    },
    created() {
      let self = this;
      self.loadKickoffFilesSetting();
      self.kickoff_files = self.prop_kickoff_files;
      self.readonly = self.prop_readonly;
      if (self.prop_basic_info != null) {
        self.basic_info = self.prop_basic_info
      }
      //console.log("self.prop_kickoff_files=>");
      //console.log(self.prop_kickoff_files);
    },
    computed: {
      filesWithDefaultCategory() {
        let self = this;
        let defaultKickoffFiles = [
          { category: 'Project Request Form', file_name: null, file_size: null, file_url: null, uni_id: null, uni_key: null, update_time: null, file_source: null, parent: false, temp_file: null },
          { category: 'Project Feasibility Check (RDS)', file_name: null, file_size: null, file_url: null, uni_id: null, uni_key: null, update_time: null, file_source: null, parent: false, temp_file: null },
          { category: 'Project SOW', file_name: null, file_size: null, file_url: null, uni_id: null, uni_key: null, update_time: null, file_source: null, parent: false, temp_file: null },
          { category: 'Project Charter DCP', file_name: null, file_size: null, file_url: null, uni_id: null, uni_key: null, update_time: null, file_source: null, parent: false, temp_file: null },
          { category: 'Project Charter Package', file_name: null, file_size: null, file_url: null, uni_id: null, uni_key: null, update_time: null, file_source: null, parent: false, temp_file: null },
          { category: 'Project Kickoff Meeting Minutes', file_name: null, file_size: null, file_url: null, uni_id: null, uni_key: null, update_time: null, file_source: null, parent: false, temp_file: null }
        ];
        let tempKickoffFiles = [];
        _.forEach(defaultKickoffFiles, file => {
          let group_files = _.filter(_.orderBy(self.kickoff_files, ['update_time'], ['desc']), { category: file.category });
          if (group_files.length > 0) {
            if (group_files.length == 1) {
              group_files[0]['parent'] = false;
            } else {
              group_files[0]['parent'] = true;
            }           
            tempKickoffFiles.push(group_files[0]);
            if (self.expand_category_list.includes(file.category)) {
              _.forEach(group_files.slice(1), children => {
                children['parent'] = false;
                tempKickoffFiles.push(children);
              });
            }   
          } else {
            tempKickoffFiles.push(file);
            self.missRequiredFile = true;
          }
        });
        return tempKickoffFiles;
      },
    },
    methods: {
      loadKickoffFilesSetting() {
        let self = this;
        self.kickoffFilesSetting = [];
        self.kickoffFilesSetting.push({ key: 'category', label: 'Category', thClass: '', tdClass: 'text-nowrap', thStyle: { width: '18rem' } });
        self.kickoffFilesSetting.push({ key: 'file_name', label: 'File Name', thClass: '', tdClass: '' });
        self.kickoffFilesSetting.push({ key: 'file_source', label: 'File Source', thClass: '', thStyle: { width: '10rem' } });
        self.kickoffFilesSetting.push({ key: 'file_size', label: 'File Size', thClass: '', thStyle: { width: '6rem' } });
        self.kickoffFilesSetting.push({ key: 'update_time', label: 'Update Time', thClass: '', thStyle: { width: '10rem' } });
      },
      deleteFile(item, type) {
        let self = this;

        //#endregion

        let requestData = {
          category: type,
          uni_key: item.uni_key,
          uni_id: item.uni_id,
          create_by: self.basic_info.createBy,
          username: self.basic_info.login_user
        };

        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/stage-management/delete_file/', requestData)
          .then(res => {
            self.reload();
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      getFile(file) {
        let self = this;
        let params = {
          file_url: file.file_url
        };
        let queryString = `file_url=${file.file_url}`;
        let url = `${self.$root.baseUrl}/stage-management/get_file/`;
        eventHub.$emit('loading', true);
        self.$axios.post(url, params, { responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', file.file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

      },
      uploadFile(temp_file, type) {
        let self = this;

        let path = null;
        switch (type) {
          case 'Project Request Form':
          case 'Project Feasibility Check (RDS)':
          case 'Project SOW':
          case 'Project Charter DCP':
          case 'Project Charter Package':
          case 'Project Kickoff Meeting Minutes':
            path = 'kickoff_files';
            break;
          default:
        }

        //#region -- Data Validate --
        let maxLength = Number(self.$root.maxRequestLength);
        if (temp_file) {
          if (temp_file.size > maxLength) {
            self.$message.warning('Maximum limit for exceeding single file uploads (10MB)');
            return;
          } else {
            //#region -- formData --
            let formData = new FormData();
            formData.append('file', temp_file);
            formData.append('category', type);
            formData.append('create_by', self.basic_info.createBy);
            formData.append('username', self.basic_info.login_user);
            formData.append('ftie_id', self.basic_info.ftie_id);
            formData.append('nre_id', self.basic_info.nre_id);
            formData.append('real_sku_no', self.basic_info.real_sku_no);
            //#endregion

            //#region -- Data Upload --

            eventHub.$emit('loading', true);
            self.$axios
              .post(
                self.$root.baseUrl + '/stage-management/upload_file/',
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
              )
              .then(res => {
                self.reload();
              })
              .finally(() => {
                eventHub.$emit('loading', false);
              });

            //#endregion
          }
        } else {
          self.$message.warning('No file');
        }

        //#endregion   

      },
      reload() {
        let self = this;
        //#region Load NreData

        let ftie_id = encodeURIComponent(self.basic_info.ftie_id);
        let nre_id = encodeURIComponent(self.basic_info.nre_id);
        let real_sku_no = encodeURIComponent(self.basic_info.real_sku_no);
        let createBy = encodeURIComponent(self.basic_info.createBy);
        let sku_id = encodeURIComponent(self.basic_info.sku_id);
        let baseUrl = _.trim(self.$root.baseUrl);

        window.location.href = `${self.$options.filters['frontendUrl']()}espm-kickoff/${ftie_id}/${sku_id}/${nre_id}/${real_sku_no}/${createBy}`;



        //#endregion

      },
      ExpandFileCategory(category) {
        let self = this;
        if (!self.expand_category_list.includes(category)) {
          self.expand_category_list.push(category);
        } else {
          self.expand_category_list = _.filter(self.expand_category_list, item => { return item !== category });
        }
      },

    }
  }</script>



// WEBPACK FOOTER //
// src/components/framework/KickoffFiles.vue